import { useURLParams } from '../contexts/ParamsContext';
import { SlotFillProvider } from '@wordpress/components';
import SiteEditorSidebar from './layout/SiteEditorSidebar';
import MainContentArea from './layout/MainContentArea';
import { Spinner } from '@wordpress/components';
import { NoticeProvider } from '../contexts/NoticeContext';

function App() {

    const { isReady } = useURLParams();

    return (
        <SlotFillProvider>
            <div className='voxycure-editor-wrap'>

                <SiteEditorSidebar />

                <NoticeProvider>
                    <div className='voxycure-editor__content'>
                        {!isReady ? (
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    height: '100%',
                                    width: '100%',
                                }}
                            >
                                <Spinner style={{ verticalAlign: 'middle' }} size={16} />
                            </div>
                        ) : (
                            <>
                                <MainContentArea />
                            </>
                        )}

                    </div>
                </NoticeProvider>
            </div>
        </SlotFillProvider>
    );
}

export default App;
